<template>
	<div class="yh-contaner">
		<!-- <MenuList style="height: calc( 100% - 60px ); "></MenuList> -->
		<MenuList style="height: 100%; "></MenuList>
	</div>
</template>

<script>
	import MenuList from '../menu/menulist'
	/* import SysHeader from './header' */
	/* import FoodsList from '../foods/foodslist' */
	export default {
		name : 'HomePage',
		data() {
			return {
				bgcolor : '#FFF  !important',
				isCollapse: false,
				/* frameUrl : '/foodslist', */
				currentpath : '',
			}
		},
		mounted() {
			console.log('home')
		},
		components: {
			MenuList
			/* SysHeader */
		},
		watch: {
			// 路由发生变化页面刷新
			/* $route(to, from) {
				if (from.path != to.path) {
					console.log(to)
					this.$router.go(0);
				}
			} */
		},
		methods: {
			
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	.yh-contaner{
		height: 100%;
	}
</style>